import { render, staticRenderFns } from "./repair-create-after-picture.vue?vue&type=template&id=3cc1a472"
import script from "./repair-create-after-picture.vue?vue&type=script&lang=js"
export * from "./repair-create-after-picture.vue?vue&type=script&lang=js"
import style0 from "./repair-create-after-picture.vue?vue&type=style&index=0&id=3cc1a472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports